import api from '.';

export const ESTADO_ENDPOINT = '/enumeraciones/estado';

export const getAllEstados = async () => {
    const response = await api.get(ESTADO_ENDPOINT);
    return response;
};
